const EMPTY = '';
const ARTICLE = 'Article';
const BLOG = 'Blog';
const RECAP = 'mlb_recap';
const RECAP_GAMEDAY = 'game-recap';
const EMPTYOBJ = {};
const PREVIEW_STORY = 'Preview Story';

class  CmsDapiArticle {

    constructor (article) {
        const { slug = EMPTY, headline = EMPTY, body, summary, contentDate, thumbnail : {templateUrl = ''} = {}} = article;
        this.id = this.slug = slug;
        this.linkId = slug;
        this.headline = headline;
        this.body = body;
        this.blurb = summary;
        this.templateUrl = templateUrl;
        this.contentDate = contentDate;

        this.parseData(article);
    }

    tagParser(tag) {
        const extra = tag && tag.extraData;
        const neutralSlug =  tag?.neutralSlug;
        if (extra) {
            if (extra === RECAP || neutralSlug === RECAP_GAMEDAY) {
                this.isRecap = true;
            }
        }
        if (tag?.externalSourceName === 'team' && extra?.id) {
            this.teamId = extra.id;
        }
    }

    parseData (data) {
        const { fields = EMPTYOBJ } = data;
        const storyType = this.storyType = fields.storyType || ARTICLE;
        var tags = data.tags;

        this.isBlog = this.isCut4 = storyType === BLOG;
        this.isArticle = storyType === ARTICLE;
        this.isRecap = false;
        this.isPreviewStory = storyType === PREVIEW_STORY;

        if (tags.length) {
            tags.forEach(this.tagParser, this);
        }
    }
};


export default CmsDapiArticle;
